module.exports = __webpack_public_path__ + "6c7a79aa806a5d4b5c16e541369772b2.pdf";